import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const TotalsGradientContainer = styled.div`
  height: ${props => `${props.height.toString()}px`};
  width: ${props => `${props.width.toString()}px`};
  display: flex;
  border-radius: 100px;
  margin-bottom: 20px;
  overflow: hidden;
  background: #DEDFE0;
  border: ${props =>
    props.totalCount === 0 ? 'border: 1px solid #CCCCCC' : 'none'}
  box-sizing: border-box;
`

const DraftBar = styled.div`
  background: #999999;
  height: inherit;
  width: ${props => `${(props.draftCount / props.totalCount) * props.width}px`};
`

const RejectedBar = styled.div`
  background: repeating-linear-gradient(
      45deg,
      #999999,
      #999999 5px,
      black 6px,
      black 6px
    )
    #999999;
  height: inherit;
  width: ${props =>
    `${(props.rejectedCount / props.totalCount) * props.width}px`};
`

const QualityReviewBar = styled.div`
  background: #000000;
  height: inherit;
  width: ${props =>
    `${(props.qualityReviewCount / props.totalCount) * props.width}px`};
`

const PublishedBar = styled.div`
  background: #00bc80;
  height: inherit;
  width: ${props =>
    `${(props.publishedCount / props.totalCount) * props.width}px`};
`

const StatusCountBar = props => (
  <TotalsGradientContainer {...props}>
    <DraftBar {...props} />
    <RejectedBar {...props} />
    <QualityReviewBar {...props} />
    <PublishedBar {...props} />
  </TotalsGradientContainer>
)

StatusCountBar.propTypes = {
  draftCount: PropTypes.number.isRequired,
  rejectedCount: PropTypes.number.isRequired,
  qualityReviewCount: PropTypes.number.isRequired,
  publishedCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
}

StatusCountBar.defaultProps = {
  height: 8
}

export default StatusCountBar



// WEBPACK FOOTER //
// ./src/components/productionstatus/StatusCountBar.js